import { RequestKind } from '@sb/library/base';
import { NameCodePair } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace CountryRoutes {
    export const Get = ApiRoute.Define({
        URL: `countries`,
        Kind: RequestKind.Get,
        ResultType: Array<NameCodePair>
    });

    export const GetProvStates = ApiRoute.Define({
        URL: (countryCode: string) => `countries/${countryCode}/provstates`,
        Kind: RequestKind.Get,
        ResultType: Array<NameCodePair>
    });
}
